export const apiUrl = "https://newsara777-api.sara777new.tech"
//export const apiUrl = "http://localhost:5002";
// export const apiUrl = window.ENV.API_URL;



